import React from 'react';
import { IChatMessage } from '../../../../../libs/models/ChatMessage';

interface ChatItemImageContentProps {
    isMe: boolean;
    message: IChatMessage;
}

export const ChatItemImageContent: React.FC<ChatItemImageContentProps> = ({ message }) => {
    return (
        <div className="w-[60%]">
            <img src={`data:image/webp;base64,${message.content}`} alt="generated image" />
        </div>
    );
};
